export const URL_COL_TEMPLATE = "40px 1fr 220px 110px 160px 80px";
export const URL_COLUMN_HEADERS = ["URL", "Tags", "Refresh Days", "Status", "Chunks"];
